// Pokud je v url kotva (například '#msg_123'), tak se odscrolluje komentář s tímto id

import { buttonsShowMoreComments } from './forumElements';

export const forumAnchorScroll = (): void => {
  const { hash } = window.location;
  if (hash.length) {
    const targetComment: HTMLDivElement | null = document.querySelector(hash);
    const header: HTMLElement | null = document.querySelector('header');

    if (!targetComment || !header) return;

    const headerHeight = header ? header.offsetHeight : 100;

    // Odkrýt zbytek vlákna, pokud není komentář viditelný
    buttonsShowMoreComments().forEach((button) => {
      if (button) button.click();
    });

    // Doscrollovat na komentář
    window.scrollTo({
      top: targetComment.offsetTop - headerHeight,
      behavior: 'smooth',
    });
  }
};
